import { useState } from 'react';
import { useApprovalDecision } from '../hooks/useApprovalDecision';
import { ApiClientError } from '@shared/api/client';

interface ApprovalActionsProps {
  approvalId: string;
}

export function ApprovalActions({ approvalId }: ApprovalActionsProps) {
  const decide = useApprovalDecision();
  const [feedback, setFeedback] = useState('');
  const [showReject, setShowReject] = useState(false);
  const [conflictMessage, setConflictMessage] = useState<string | null>(null);

  const handleDecision = (decision: 'approved' | 'rejected') => {
    setConflictMessage(null);
    decide.mutate(
      { approvalId, decision, feedback: decision === 'rejected' ? feedback : undefined },
      {
        onError: (error) => {
          if (error instanceof ApiClientError && error.status === 409) {
            setConflictMessage('Already decided from another interface');
          }
        },
      }
    );
  };

  if (conflictMessage) {
    return (
      <div className="text-sm rounded-lg p-3 bg-yellow-50 border border-yellow-200 text-yellow-700">
        {conflictMessage}
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="flex gap-2">
        <button
          onClick={() => handleDecision('approved')}
          disabled={decide.isPending}
          className="btn btn-primary text-sm"
        >
          Approve
        </button>
        <button
          onClick={() => setShowReject(!showReject)}
          disabled={decide.isPending}
          className="btn btn-outline text-sm"
        >
          Reject
        </button>
      </div>

      {showReject && (
        <div className="space-y-2">
          <textarea
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            placeholder="Feedback for rejection..."
            className="input"
            rows={2}
          />
          <button
            onClick={() => handleDecision('rejected')}
            disabled={decide.isPending || !feedback}
            className="btn bg-red-500 text-white hover:bg-red-600 text-sm"
          >
            Confirm Reject
          </button>
        </div>
      )}
    </div>
  );
}
